import { render, staticRenderFns } from "./CookiePreferencesModal.vue?vue&type=template&id=79d17969&scoped=true"
import script from "./CookiePreferencesModal.vue?vue&type=script&lang=js"
export * from "./CookiePreferencesModal.vue?vue&type=script&lang=js"
import style0 from "./CookiePreferencesModal.vue?vue&type=style&index=0&id=79d17969&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d17969",
  null
  
)

export default component.exports